import React from "react";
import {Row} from "react-bootstrap";
import NawCompaniesDetailsOffersTable from "./NawCompaniesDetailOffersTable";

export default function NawCompaniesDetailOffersTableHandler({companyOffers}) {
  //laat tabel zien met gegevens via props
  if (companyOffers.length > 0) return <NawCompaniesDetailsOffersTable companyOffers={companyOffers} />;
  else
    return (
      <Row className="justify-content-center align-self-center w-100 text-center">
        Geen offertes van dit bedrijf gevonden.
      </Row>
    );
}

